import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const EntertainmentIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "EntertainmentIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1156 19.8106C21.4391 19.8106 21.7013 19.5483 21.7013 19.2248V10.9108C21.7013 10.6208 21.4891 10.3744 21.2023 10.3315L13.3831 9.15995C13.2145 9.13469 13.0432 9.18415 12.9141 9.29542C12.7849 9.40669 12.7106 9.56873 12.7106 9.73923V18.0532C12.7106 18.3767 12.9728 18.639 13.2963 18.639C13.6198 18.639 13.8821 18.3767 13.8821 18.0532V10.4193L20.5298 11.4153V19.2248C20.5298 19.5483 20.7921 19.8106 21.1156 19.8106Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6948 13.8443C21.7428 13.5244 21.5223 13.2262 21.2023 13.1782L13.3831 12.0067C13.0632 11.9588 12.765 12.1793 12.717 12.4992C12.6691 12.8191 12.8896 13.1173 13.2095 13.1653L21.0288 14.3368C21.3487 14.3847 21.6469 14.1642 21.6948 13.8443Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.3324 18.0535C8.3324 19.5859 9.57461 20.8283 11.1071 20.8283C12.6395 20.8283 13.8821 19.5857 13.8821 18.0532C13.8821 16.5208 12.6395 15.2788 11.1071 15.2788C9.57462 15.2788 8.3324 16.5211 8.3324 18.0535ZM11.1071 19.6568C10.2217 19.6568 9.50389 18.939 9.50389 18.0535C9.50389 17.1681 10.2216 16.4503 11.1071 16.4503C11.9925 16.4503 12.7106 17.1678 12.7106 18.0532C12.7106 18.9387 11.9925 19.6568 11.1071 19.6568Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.27002 11.8411C3.27002 13.3735 4.51228 14.6158 6.04473 14.6158C7.57718 14.6158 8.81945 13.3735 8.81945 11.8411C8.81945 10.3086 7.57717 9.06636 6.04473 9.06636C4.5123 9.06636 3.27002 10.3086 3.27002 11.8411ZM6.04473 13.4443C5.15931 13.4443 4.44151 12.7265 4.44151 11.8411C4.44151 10.9556 5.15929 10.2379 6.04473 10.2379C6.93017 10.2379 7.64796 10.9556 7.64796 11.8411C7.64796 12.7265 6.93016 13.4443 6.04473 13.4443Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1517 19.2252C16.1517 20.7577 17.3939 22 18.9263 22C20.4588 22 21.7013 20.7573 21.7013 19.2248C21.7013 17.6924 20.4588 16.4505 18.9263 16.4505C17.3939 16.4505 16.1517 17.6928 16.1517 19.2252ZM18.9263 20.8285C18.0409 20.8285 17.3232 20.1107 17.3232 19.2252C17.3232 18.3398 18.0409 17.622 18.9263 17.622C19.8118 17.622 20.5298 18.3394 20.5298 19.2248C20.5298 20.1103 19.8118 20.8285 18.9263 20.8285Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.23361 12.4265C8.55711 12.4265 8.81945 12.1646 8.81945 11.8411L8.81936 6.09588L13.1239 6.63346C13.2906 6.65428 13.4582 6.60251 13.5842 6.49132C13.7101 6.38014 13.7823 6.22022 13.7823 6.05223V3.20547C13.7823 2.91003 13.5622 2.66084 13.2691 2.62424L8.30619 2.00452C8.13949 1.9837 7.97187 2.03546 7.84593 2.14665C7.72 2.25784 7.64787 2.41775 7.64787 2.58575V5.42467C7.64778 5.43035 7.64778 5.43601 7.64787 5.44166L7.64796 11.8411C7.64796 12.1646 7.91011 12.4265 8.23361 12.4265ZM8.81936 4.91529V3.24918L12.6108 3.72262V5.38878L8.81936 4.91529Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default EntertainmentIcon;
